import {createContext} from 'react';
export const IdiomContext = createContext()